import Clarity from '@microsoft/clarity'
import { AppProvider as ShopifyAppProvider } from '@shopify/polaris'
import enTranslations from '@shopify/polaris/locales/en.json'
import React, { useCallback } from 'react'
import { Link as ReactRouterLink, RouteComponentProps, withRouter } from 'react-router-dom'
import Rollbar from 'rollbar'

import { useSaveBarContext } from '../common/SaveBar'

export const setupRollbar = (shopOrigin?: string) => {
  ;(window as any).rollbar = new Rollbar({
    accessToken: process.env.REACT_APP_ROLLBAR_CLIENT_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: process.env.REACT_APP_APP_ENV,
      person: {
        id: shopOrigin ?? null,
      },
    },
    transform: function (payload: any) {
      let isExternal = false
      const trace = payload.body.trace
      if (trace && trace.frames) {
        for (let i = 0; i < trace.frames.length; i++) {
          const filename = trace.frames[i].filename
          if (filename && !filename.includes('paywhirl')) {
            isExternal = true
          }
        }
        if (isExternal && trace.exception?.description) {
          trace.exception.description = `[external] ${trace.exception.description}`
        }
      }
    },
  })
}

export const setupClarity = (shopOrigin?: string) => {
  if (!shopOrigin) {
    return
  }

  Clarity.init('y48gw0k1d6')
  Clarity.consentV2()
  Clarity.identify(shopOrigin)
}

export const AdapterLink = ({ children, onClick, url, ...rest }: any) => {
  const external = url.startsWith('http')
  const saveBar = useSaveBarContext()
  const newTab = external && !onClick

  const handleClick = useCallback(() => {
    if (!shopify || !shopify.saveBar) {
      return true
    }

    if (saveBar.isOpen) {
      shopify.saveBar.leaveConfirmation()
    }
  }, [saveBar])

  return external ? (
    <a
      href={url}
      rel="noopener noreferrer"
      target={newTab ? '_blank' : undefined}
      onClick={handleClick}
      children={children}
    />
  ) : (
    <ReactRouterLink to={url!} onClick={handleClick} children={children} {...rest} />
  )
}

export const AppProvider = ({ children }: { children: any }) => (
  <ShopifyAppProvider i18n={enTranslations} linkComponent={AdapterLink} children={children} />
)

export const AdminRoutePropagator = withRouter((props: RouteComponentProps) => {
  window.parent.postMessage({ newPathname: props.location.pathname }, '*')
  return null
})
